import React from 'react';

const Reports = () => {
  return (
    <div style={{ padding: '20px', borderRadius: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
      <h3>Reports</h3>
      <p>View and analyze system reports.</p>
      <div>
        <h4>User Activity</h4>
        <button style={{ backgroundColor: '#fb9678', color: '#fff', border: 'none', padding: '10px 15px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>Download Report</button>
      </div>
      <div>
        <h4>System Performance</h4>
        <button style={{ backgroundColor: '#fb9678', color: '#fff', border: 'none', padding: '10px 15px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>Download Report</button>
      </div>
    </div>
  );
};

export default Reports;
